import { FC, ReactNode } from "react";

export interface BadgeProps extends React.ComponentPropsWithoutRef<"span"> {
  children: ReactNode;
  className?: string;
}

const Badge: FC<BadgeProps> = ({ children, className, ...rest }) => {
  return (
    <span
      role="status"
      style={{ width: "fit-content" }}
      className={["unchained-badge", className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </span>
  );
};

export default Badge;
